module.exports = __webpack_public_path__ + "static/media/qc.89353974.svg";